import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import React, { useMemo } from 'react';
import { uuid } from '../../../../CodesThatsGottaGoSomewhereElse';
import { Spinner } from '../../../../ui';
import { Copy, Flexer } from '../../../dashboard/elements/LayoutElements';

const WorkingIndicatorInner = ({ fetching, mutating }: WorkingIndicatorProps) => {

    const anyFetching = fetching?.map(x => useIsFetching([x]))?.some(x => !!x) ?? false;
    const anyMutating = mutating?.map(x => useIsMutating([x]))?.some(x => !!x) ?? false;
    const working = anyFetching || anyMutating;

    if (!working) return null;

    return <Flexer flex="row" gap=".25">
        <Spinner size={1.5} />
        <Copy flush>Working</Copy>
    </Flexer>;
};

export type WorkingIndicatorProps = {
    fetching?: string[],
    mutating?: string[],
};

export const WorkingIndicator = React.memo((props: WorkingIndicatorProps) => {
    const inputs = [...(props.fetching ?? []), ...(props.mutating ?? [])];
    const key = useMemo(() => uuid(), [inputs]);
    return <WorkingIndicatorInner key={key} {...props} />;
});

